 <template>
  <div>
    <Nav :Logo="Logo"/>
    <div class="pageWD mT20">
      <div class="flex flex-sb">
        <div style="width:884px;height:405px;border-radius:8px">
          <el-carousel :interval="5000" arrow="always" v-if="banners" style="border-radius:8px">
              <el-carousel-item v-for="(item,index) in  banners" :key="index">
                <img :src="item.cbUrl" style="width:884px;height：405px;border-radius:8px" />
              </el-carousel-item>
          </el-carousel> 
        </div>
        <div class="shadowBox repBox">
           <div class="c3 f18 rtit">学习报告</div>
           <div class="r r1 c3" :class="[repIndex=='1'?'shadowMe':'']" @mouseover="tapMouseOverR('1')" @mouseleave="tapMouseLeaveR('1')">
               <span v-if="timeData.time">{{$conFun.MinToHours(timeData.time)}}</span>
               <span v-else>未记录</span>
           </div>
           <div class="r r2 c3" :class="[repIndex=='2'?'shadowMe':'']" @mouseover="tapMouseOverR('2')" @mouseleave="tapMouseLeaveR('2')"><span>{{$conFun.MinToHours(timeData.allTime)}}</span></div>
           <div class="r r3 c3" :class="[repIndex=='3'?'shadowMe':'']" @mouseover="tapMouseOverR('3')" @mouseleave="tapMouseLeaveR('3')">
               <span v-if="timeData.rank">第 {{timeData.rank}} 名</span>
               <span v-else>未上榜</span>
           </div>
        </div>
      </div>
      <div v-if="notices">
        <div class="notices shadowBox mT20" v-if="notices.length!= 0" >    
            <el-carousel height="18px" direction="vertical" >
              <el-carousel-item v-for="(item,index) in notices" :key="index">
                  <div  @click="noticeDetail(item.noId,index)">
                  {{item.noTitle}}<span style="margin-left:40px">{{$conFun.parseData(item.noCreatedon)}}</span>
                  </div>
              </el-carousel-item>
            </el-carousel>     
          <router-link :to="{path:'home/notice'}" class="links f14">更多 ></router-link>
         </div> 
     </div>   

      <div class="shadowBox mT20">
        <div class="pheader flex flex-sb">
           <img src="../assets/images/wodekecheng.png" style="width:142px; height:58px" />
           <router-link  :to="{path:'home/course?type=course'}" class="links f14">更多 ></router-link>          
        </div>
        <div>
          <ul class="plist">
             <li v-for="(item,index) in classies" :key="index" @click="toPlay(item.cmId)">
                 <ClassItem  :index="index" :item="item"  type= '1'/>
             </li>
             <div v-if="classies.length < 4 ">
               <li v-for="(item,index) in (4-classies.length)" :key="index" >
                  <EmptyItem  :index="index" />     
               </li>
             </div> 
              <div v-if="classies.length > 4 && classies.length < 8 ">
               <li v-for="(item,index) in (8-classies.length)" :key="index" >
                  <EmptyItem  :index="index" />     
               </li>
             </div> 
          </ul>
        </div>
      </div>     
      <div class="shadowBox mT20">
        <div class="pheader flex flex-sb">
           <img src="../assets/images/jinqixuexi.png" style="width:142px; height:58px" />
           <router-link  :to="{path:'home/course?type=history'}" class="links f14" >更多 ></router-link>
        </div>
        <div>
          <ul class="plist" v-if="historylist.length!=0">
             <li v-for="(item,index) in historylist" :key="index" @click="toSee(item)">           
                <div  v-if="item.WH_ClassType=='4'" >                
                    <KnowItem :index="index" :item="item"/>         
                </div> 
                <div  v-if="item.WH_ClassType=='1'||item.WH_ClassType =='2' ||item.WH_ClassType =='3'">
                    <ClassItem :index="index" :item="item" type= '2'/>           
                </div>               
             </li> 
             <div v-if="historylist.length < 4">
               <li v-for="(item,index) in (4-historylist.length)" :key="index">
                  <EmptyItem  :index="index" />     
               </li>
             </div> 
          </ul> 
          <div v-else>
            <Empty />
          </div>          
        </div>
      </div>
      <div style="height:20px"></div>
      <div class="showhobby" v-if="chooseCategory=='0'">
            <el-dialog          
            :visible.sync="centerDialogVisible"
            custom-class="eldialog"
            :close-on-click-modal	="cl"
            :show-close="cl"
            :close-on-press-escape="cl"
            center>
            <div>            
            </div>
            <span slot="footer" class="dialog-footer">
              <div class="flex flex-sb" style="padding:0 24px"> <img src="../assets/images/xuanzexihao.png" style="width:152px;height:58px" /><span class="c9 f14">请选择一项您感兴趣的内容</span></div>
              <div class="hobbys flex" >
                 <div class="block" v-for="(item,index) in hobbys" :key="index"  :class="[hobbyIndex==index?'hobbyActive':'',item.checked?'hobbySelect':'']"  @click="selectHobby(index)" @mouseover="tapMouseOverH(index)" @mouseleave="tapMouseLeaveH(index)">
                     <div><img :src="item.checked ? item.icon2:item.icon1"  style="width:64px;height:64px" /></div>
                     <div>{{item.name}}</div>
                  </div>
              </div>
              <el-button  @click="subHobby" :class="[selectLens!=0?'el-active':'']" >确定提交</el-button>
            </span>
          </el-dialog>         
      </div>
    </div> <AudioTip :isTip="isTip"  @hideMe="hideMeHome" />
     <div class="fotter">
      <div class="pageWD">
        <div class="about">关于我们</div>
        <div class="flex">
          <div class="f16 c3">
            <div>公司名称：世华企业管理集团有限公司</div>
            <div>客服电话：166 0131 6572</div>
            <div>公司地址：北京市朝阳区联美大厦12层</div>
            <div>京公网安备：11010502045856号 京ICP备：19027979号-3</div>
          </div>
          <div>
           <img src="@/assets/images/er.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSecollect ,saveCourseCollect , getTimePai ,getClassData,getHomeData,getStudyHistory } from '@/api/api'
import Cookies from "js-cookie";
import Nav from "../components/Nav.vue";
import Empty from "../components/Empty.vue";
import ClassItem from "../components/ClassItem.vue";
import KnowItem from "../components/KnowItem.vue";
import EmptyItem from "../components/EmptyItem.vue";
import AudioTip from "../components/AudioTip.vue";
export default {
  components: { Nav,Empty,ClassItem,KnowItem,EmptyItem,AudioTip},
  data() {
    return {
      isTip:false,
      cl:false,
      classies:[],      
      hobbys:[
        {
          icon1:require('../assets/images/hobby/yingxiao1.png'),
          icon2:require('../assets/images/hobby/yingxiao2.png'),
          name:'营销推广',
          checked:false,
          id:'1'
         },
         {
          icon1:require('../assets/images/hobby/xiaoshou1.png'),
          icon2:require('../assets/images/hobby/xiaoshou2.png'),
          name:'销售成交',
          checked:false,
          id:'2'
        }
        ,{
          icon1:require('../assets/images/hobby/bangong1.png'),
          icon2:require('../assets/images/hobby/bangong2.png'),
          name:'办公工具',
          checked:false,
          id:'3'
        },{
          icon1:require('../assets/images/hobby/goutong1.png'),
          icon2:require('../assets/images/hobby/goutong2.png'), 
          name:'沟通谈判',
          checked:false,
          id:'4'
        },{
          icon1:require('../assets/images/hobby/renli1.png'),
          icon2:require('../assets/images/hobby/renli2.png'), 
          name:'人力资源',
          checked:false,
          id:'5'
        },{
          icon1:require('../assets/images/hobby/caiwu1.png'),
          icon2:require('../assets/images/hobby/caiwu2.png'),
          name:'财务管理',
          checked:false,
          id:'6'
        },{
          icon1:require('../assets/images/hobby/zhichang1.png'),
          icon2:require('../assets/images/hobby/zhichang2.png'), 
          name:'职场思维',
          checked:false,
          id:'7'
        },{
          icon1:require('../assets/images/hobby/zhiye1.png'),
          icon2:require('../assets/images/hobby/zhiye2.png'),
          name:'职业规划',
          checked:false,
          id:'8'
        }
      ],
      timeData:'',
      chooseCategory :'',
      btdisabled:true,
      centerDialogVisible: true,
      disabled:true,     
      emptyIndex:'-1',      
      hobbyIndex:'-1',
      repIndex:'-1',
      strokeWidth:8,
      showText:false,
      activeNav: "1",
      activeIndex: "1",
      userInfor: "",
      compList:'',
      userID:'',
      qslCOID:'',
      banners:null,
      Logo:null,
      classiesLens:null,
      historylist:[],
      notices:null
    };
  },
  created() { 
    document.title = '企胜力'  
    this.userID = Cookies.get('qsluserId') 
    this.qslCOID = Cookies.get('qslCOID') 
    this.qslmemberId = Cookies.get('qslmemberId') 
    const qslmemberName = Cookies.get("qslmemberName");    
    if(typeof(qslmemberName) =='undefined'){ 
      this.getUserInfo()        
    }   
    this.IsSecollect()//是否显示选择学习喜好弹框
    this.getTimePaiData()//学习报告
    this.getClassList()//获取课程列表
    this.getHomeDataList()//首页轮播、公告
    this.getStudyHistoryFun()
  },
  computed:{
     selectLens:function(){
       let lens = 0      
       for(let i=0;i<this.hobbys.length;i++){
         if(this.hobbys[i].checked){
           lens++
         }
       }
       return lens
     },
     selectIDs:function(){
       let IDS = ''      
       for(let i=0;i<this.hobbys.length;i++){
         if(this.hobbys[i].checked){
           IDS += ','+this.hobbys[i].id
         }
       }
       return IDS.substr(1)
     }

  },
    watch: {
      $route(to, from) {      
        this.$router.go(0)
        // 对路由变化作出响应...
        //可以使用$router.go(0)进行刷新,
        //可以改用window.location.reload()
      }
  },
  methods: {
    getStudyHistoryFun(){
        var that = this;
        let data = {
          memberId: Cookies.get('qslmemberId'),
        };
        getStudyHistory(data)
        .then(res => {            
         that.historylist = res.body.result.slice(0,4)        
        })
        .catch(err => {});
    },
    toPlay(id){
      this.$router.push({path:'home/play',query:{courseId:id}});
    },
    toSee(item){//WH_ClassType：1、课程 2、语音直播 3、视频直播 4、文档
       if(item.WH_ClassType == '1'){
          this.$router.push({path:'home/play',query:{courseId:item.WH_ClassID}});
       }
       if(item.WH_ClassType == '2'){
          this.isTip = true
       }
        if(item.WH_ClassType == '3'){
          item.attr2 =='直播中'?this.$router.push({path:'Live',query:{liId:item.WH_PartID}}):this.$router.push({path:'Lookback',query:{liId:item.WH_PartID}})
       }
        if(item.WH_ClassType == '4'){
          this.$router.push({path:'/Knowledge/view',query:{fiId:item.WH_PartID}});
       }      
    },
     noticeDetail(noId,index){     
       this.$router.push({path: 'home/notice', query: {noId: noId,index:index}});
     },
     getUserInfo() {
       
      this.$store
        .dispatch("GetInfo")
        .then((res) => {   
          console.log(res.body.result)
          Cookies.set('qslmemberName',res.body.result.memberName)             
         	Cookies.set('qsluserheadpic',res.body.result.userheadpic) 
           
        })
        .catch((err) => {
          console.log(err);
        });
    },
    hideMeHome(){
      this.isTip = false
    },
    getClassList() {
        var that = this;
        let data = {
          memberId: Cookies.get('qslmemberId'),
          COID: Cookies.get('qslCOID'),
          pageIndex: 1,
          pageSize: 9,
          courseType: 0
        };
        getClassData(data)
        .then(res => {            
          that.classiesLens = res.body.result.length        
          that.classies = res.body.result.slice(0,8)         
        })
        .catch(err => {});
    }, 
    getHomeDataList () {
			var that = this;
			let data = {
				memberId: Cookies.get('qslmemberId'),
				COID: Cookies.get('qslCOID')
			};
			getHomeData(data)
				.then(res => {     
          
					that.banners = res.body.result.bannerUrl;
					that.notices = res.body.result.newNotice;		
          Cookies.set('qslCOLOGO',res.body.result.Logo)  
          that.Logo = res.body.result.Logo
				})
				.catch(err => {});
		},   
    getTimePaiData() {
			var that = this;
			let data = {
				memberId: Cookies.get('qslmemberId') ,
				coId: Cookies.get('qslCOID'),
			};
			getTimePai(data)
				.then(res => {
					that.timeData = res.body.result;
				})
				.catch(err => {});
		},
    subHobby(){
        var that = this
        if(this.selectLens!='0'){        
          this.$confirm('确认选择好了？', '请确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
             that.SaveSecollect(that.selectIDs)            
          }).catch(() => {                  
          });
        }
    },
    selectHobby(index){
      this.hobbys[index].checked = !this.hobbys[index].checked
    },
    IsSecollect(){
      let data = {
        userId: Cookies.get('qsluserId')
      };
      var that = this
      getSecollect(data)
        .then(res => {          
          that.chooseCategory  = res.body.result.chooseCategory 
        })
        .catch(err => {});
    } ,
    SaveSecollect(courseClass){
      let data = {
        COID: Cookies.get('qslCOID'),
        memberId:Cookies.get('qslmemberId') ,
        courseClass:courseClass
      };
      var that = this
      saveCourseCollect(data)
        .then(res => {         
          if(res.body.result == '1'){
             this.$message({
              type: 'success',
              message: '保存成功!'
             });             
             setTimeout(() => {
                this.$router.go(0)
              }, 300);              	
          }
        })
        .catch(err => {});
    } ,
    tapMouseOverR(index){
       this.repIndex = index
    },
     tapMouseLeaveR(index){
       this.repIndex = '-1'
    },
    tapMouseOverH(index){
       this.hobbyIndex = index
    },
    tapMouseLeaveH(index){
       this.hobbyIndex = '-1'
    }   
  },
};
</script>    
<style>
.showhobby .hobbys{
  display:flex;
  flex-wrap:wrap;
  margin-bottom:16px;
  margin-top:7px;
  cursor: pointer
}
.showhobby .hobbys .block{
  width:160px;
  height:160px;
  text-align:center;
  margin-left:24px;
  margin-bottom:24px;
  display:flex;
  flex-direction: column; 
  flex-wrap:wrap;
  justify-content: center;
  align-items: center;
  color:#999;
  font-size:18px;
}
.showhobby .hobbys img{
  width:64px;
  height:64px;
  margin-bottom:26px
}
.showhobby .hobbys .hobbyActive{
   background:#e4f0fe;
  border-radius: 8px;
  box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.10); 
}
.showhobby .hobbys .hobbySelect{
  background:#4B9AFB;
  border-radius: 8px;
  box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.10); 
  color:#fff;
}
.showhobby .el-dialog__header,.el-dialog--center .el-dialog__body{
  display:none
}
.showhobby .el-dialog__footer{
  padding:24px 0
}
.showhobby .eldialog{
  width: 761px;
  height: 587px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.10); 
}
.showhobby .el-button{
  width: 361px;
  height: 56px;
  background: #cccccc;
  border-radius: 8px;
  border:0;
  font-size:24px;
  color:#ffffff
}
.showhobby .el-active{
  background:#4B9AFB
}
.repBox{
  height:405px;
  width:292px
}
.repBox .r{
  width: 244px;
  height: 92px;
  position:relative;
  font-size:18px;
  border-radius: 8px;
  margin-left:24px;
  margin-bottom:18px
}
.repBox .rtit{
  height: 64px;
  padding-left:22px;
  line-height:64px;
  background: #ffffff;
  border-radius: 8px 8px 0px 0px;
  box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.10); 
  margin-bottom:15px;

}
.repBox .r span{
  left:24px;
  bottom:19px;
  position:absolute
}
.repBox .r1{
  background:url('../assets/images/jirixuexi.png') no-repeat;
}
.repBox .r2{
  background:url('../assets/images/zongshichang.png') no-repeat;
}
.repBox .r3{
  background:url('../assets/images/xuexipaiming.png') no-repeat;
}

.notices{
  padding:13px 24px 13px 65px;
  background:url("../assets/images/tongzhi.png") 24px center no-repeat #fff;
  position:relative;
  cursor: pointer;
}
.el-carousel__container {
  height:405px;
  margin: 0;
}
.links{
  color:#4B9AFB
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
.notices .el-carousel__item{
  background:#fff;
  font-size:14px;
  color:#333
}
.notices .links{
  position:absolute;
  right:24px;
  top:12px
}
.notices .el-carousel{
  width:800px
}

</style>





// WEBPACK FOOTER //
// src/views/index.vue